import { Box, Group, Text } from '@mantine/core'
import { GlowAvatar } from '../common/GlowAvatar'
import { MarkdownRenderer } from '../common/MarkdownRenderer'
import { StreamingCursor } from './StreamingCursor'
import { SpeakButton } from '../game2/SpeakButton'
import { stripSsml } from '../../lib/responseParser'

export function ChatMessage({ role, content, characterName, characterAvatar, isStreaming, timestamp, speakSegment }) {
  const isUser = role === 'user'

  const formattedTime = timestamp
    ? new Date(timestamp).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
    : null

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        marginBottom: 8,
      }}
    >
      <Box style={{ maxWidth: '85%', display: 'flex', gap: 8, flexDirection: isUser ? 'row-reverse' : 'row' }}>
        {/* Character avatar for assistant messages */}
        {!isUser && (
          <Box style={{ flexShrink: 0, alignSelf: 'flex-start', marginTop: 4 }}>
            <GlowAvatar src={characterAvatar} name={characterName} size={52} />
          </Box>
        )}

        <Box>
          {/* Message bubble */}
          <Box
            px="sm"
            py="xs"
            style={{
              background: isUser
                ? 'rgba(0, 229, 255, 0.1)'
                : 'rgba(10, 22, 40, 0.8)',
              border: `1px solid ${isUser ? 'rgba(0, 229, 255, 0.2)' : 'rgba(255, 255, 255, 0.08)'}`,
              borderRadius: isUser ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
              fontFamily: 'var(--bw-body-font)',
              lineHeight: 1.5,
            }}
          >
            <MarkdownRenderer content={stripSsml(content || '')} />
            {isStreaming && <StreamingCursor />}
          </Box>

          {/* Timestamp + speak control (assistant messages only) */}
          <Group gap={4} mt={2} justify={isUser ? 'flex-end' : 'flex-start'} wrap="nowrap">
            {formattedTime && (
              <Text size="xs" c="dimmed" ff="Rajdhani, sans-serif">
                {formattedTime}
              </Text>
            )}
            {!isUser && !isStreaming && speakSegment && <SpeakButton segment={speakSegment} size="xs" />}
          </Group>
        </Box>
      </Box>
    </Box>
  )
}
